import instagram from './instagram.png';
import tiktok from './tiktok.png';
import youtube from './youtube.png';

const platformIcons = {
	youtube,
	instagram,
	tiktok
};

export default platformIcons;
